export const ICON_CLASSES = {
  DOWNLOAD_ICON: 'fa fa-download',
  CALENDAR: 'fa fa-calendar',
  FACEBOOK: 'fab fa-facebook-f',
  STRAVA: 'fab fa-strava',
  CHECK: 'fa fa-check',
  CART: 'fa-solid fa-cart-shopping',
  EMAIL: 'fa-solid fa-envelope',
  INSTAGRAM: 'fab fa-instagram'
}